import { Banner } from "../../Contracts/Banner";
import { create } from "zustand";

export interface BannerState {
  activeBanners: Banner[];
  addBanner: (options: Omit<Banner, "id"> & { id?: string }) => void;
  removeBanner: (banner: Banner) => void;
  removeAllBanners: () => void;
}

export const useBannerStore = create<BannerState>(set => {
  const addBanner = (options: Omit<Banner, "id"> & { id?: string }) => {
    if (!options.message?.trim()) {
      return;
    }
    const newBanner: Banner = {
      id: options.id || Math.random().toString(36).substring(2, 15),
      ...options
    };
    set(state => ({
      activeBanners: [...state.activeBanners, newBanner]
    }));
  };

  const removeBanner = (banner: Banner) => {
    banner.onClose && banner.onClose();
    set(state => ({
      activeBanners: state.activeBanners.filter(b => b !== banner)
    }));
  };

  const removeAllBanners = () => {
    set({ activeBanners: [] });
  };

  return {
    activeBanners: [],
    addBanner,
    removeBanner,
    removeAllBanners
  };
});
